<template>
  <header class="header">
    <ProfilePreview :status="status"/>

    <!--    <SearchBar :status="status"/>-->

    <router-link class="header__logo" :to="{name: 'root'}">
      <img alt="Fusebox Logo" src="@/assets/svg/fusebox_online_logo.svg">
    </router-link>

    <label class="header__hamburger" @click="setMenuActive(!menuactive)">

      <div class="header__hamburger__bar"></div>
      <div class="header__hamburger__bar"></div>
      <div class="header__hamburger__bar"></div>

    </label>

  </header>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ProfilePreview from '@/components/Profile/ProfilePreview.vue'
// import SearchBar from '@/components/Parts/SearchBar.vue'

export default {
  name: 'Header',
  props: ['status'],
  components: {
    ProfilePreview
    // SearchBar
  },
  data () {
    return {
      results: ''
    }
  },
  methods: {
    ...mapActions('menu', [
      'setMenuActive'
    ])
  },
  computed: {
    ...mapState('menu', [
      'menuactive'
    ])
  }
}
</script>
